// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__iuFM0","name":"Affair_name__pesc6","closeButton":"Affair_closeButton__h+o+b"};